import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  ExistingControl,
  MaturityRateResponse,
} from '../../types/existingControlTypes'
import {
  addExistingControlApi,
  deleteExistingControlApi,
  getAllExistingControls,
  getExistingControlbyIdApi,
  getMaturityRateForExistingControls,
  updateExistingControlApi,
} from '../../api/existingControlsApi'
import { handleError } from '../../utils/errorHandler'

export const getExistingControls = createAsyncThunk<
  {
    existingControls: ExistingControl[]
    total: number
    totalPages: number
    status?: number
    erreur?: boolean
    message?: string
  },
  { search?: string; page?: number; pageSize?: number },
  { rejectValue: string }
>(
  'existingControl/getAllExistingControls',
  async ({ search, page, pageSize }, thunkAPI) => {
    try {
      const response = await getAllExistingControls({ search, page, pageSize })
      return {
        existingControls: response.existingControls,
        total: response.total,
        totalPages: response.totalPages,
        status: response.status,
        message: response.message,
        erreur: response.erreur,
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)

export const getMaturityRateForExistingControl = createAsyncThunk<
  MaturityRateResponse,
  void,
  { rejectValue: string }
>(
  'existingControls/getMaturityRateForExistingControls',
  async (_, thunkAPI) => {
    try {
      const response: MaturityRateResponse =
        await getMaturityRateForExistingControls()
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)

export const deleteExistingControl = createAsyncThunk<
  void,
  string,
  { rejectValue: string }
>('existingControl/deleteExistingControl', async (AuditId, thunkAPI) => {
  try {
    await deleteExistingControlApi(AuditId)
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const addExistingControl = createAsyncThunk<
  ExistingControl,
  ExistingControl,
  { rejectValue: string }
>(
  'existingControl/addExistingControl',
  async (newExistingControl, thunkAPI) => {
    try {
      const response = await addExistingControlApi(newExistingControl)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)
export const getExistingControlbyId = createAsyncThunk<
  ExistingControl,
  string,
  { rejectValue: string }
>(
  'existingControl/getExistingControlbyId',
  async (ExistingControlId, thunkAPI) => {
    try {
      const response = await getExistingControlbyIdApi(ExistingControlId)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)

export const updateExistingControl = createAsyncThunk<
  ExistingControl,
  { updatedExistingControl: ExistingControl; _id: string },
  { rejectValue: string }
>(
  'existingControl/updateExistingControl',
  async ({ updatedExistingControl, _id }, thunkAPI) => {
    try {
      const response = await updateExistingControlApi(
        updatedExistingControl,
        _id
      )
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)
